var generateStyle = function generateStyle(componentTheme) {
  return {
    instructions: {
      paddingBottom: componentTheme.instructionsPaddingBottom
    }
  };
};
export default generateStyle;